import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const getCookie = (cookieString: string) => {
  if (isSSR()) {
    // Remove the trailing semicolon if it exists
    if (cookieString.at(-1) === ";") {
      return cookieString.slice(0, -1);
    }

    return cookieString;
  }

  return document.cookie;
};

/**
 * Isomorphic function to extract cookies from a cookie string or document.cookie
 * If running on the server side, cookieString is required otherwise it will return an empty object
 */
const cookieExtractor = (cookiesToExtract: string[], cookieString?: string) => {
  if (isSSR() && !cookieString) {
    return {};
  }

  const cookies = getCookie(cookieString!).split(";");

  return cookies.reduce<Record<string, string>>((matchingCookies, cookie) => {
    const [cookieName, cookieValue] = cookie.trim().split("=");

    if (cookiesToExtract.includes(cookieName)) {
      matchingCookies[cookieName] = cookieValue;
    }

    return matchingCookies;
  }, {});
};

export { cookieExtractor };
